import { BrowserRouter, Route, Routes } from "react-router-dom";
import { Toaster } from "sonner";
import { LanguageProvider } from "@/context/AppContext";
import Landing from "@/pages/Landing";
import Admin from "@/pages/Admin";

function App() {
  return (
    <LanguageProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/admin" element={<Admin />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="bottom-center" />
    </LanguageProvider>
  );
}

export default App;
